import { Dialog, TextField } from "@mui/material";
import { useState, useMemo } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DialogContentFiltroTipoMovimento from "./DialogContentFiltroTipoMovimento";


export type TTipoMovimento = {
    "6": "S" | "N";
    "7": "S" | "N";
    "8": "S" | "N";
    "9": "S" | "N";
}

export default function FiltroTipoMovimento({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    label = 'Tipo de Movimento',
    disabled = false,
    onChange
}: FiltroTipoMovimentoProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = useMemo(() => {
        if (!value) return "";

        const filtrosAtivos = Object.entries(value)
            .filter(([key, valor]) => ["6", "7", "8", "9"].includes(key) && valor === "S")
            .map(([key, _]) => {
                const labels = {
                    "6": "Movimento 6",
                    "7": "Movimento 7",
                    "8": "Movimento 8",
                    "9": "Movimento 9"
                };
                return labels[key as keyof typeof labels];
            });

        return filtrosAtivos.length > 0 ? filtrosAtivos.join(", ") : "Nenhum selecionado";
    }, [value]);

    const defaultValue: TTipoMovimento = {
        "6": "N",
        "7": "N",
        "8": "N",
        "9": "N"
    };

    return (
        <>
            <TextField
                disabled={disabled}
                {...{ required, error }}
                label={label}
                variant="outlined"
                fullWidth
                onClick={() => { if (!disabled) setOpenModal(true) }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: {
                        readOnly: true,
                        endAdornment: <KeyboardArrowDownIcon />
                    }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {openModal && (
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentFiltroTipoMovimento
                        handleClose={handleClose}
                        defaultValue={value || defaultValue}
                        onChange={(newValue) => {
                            onChange(newValue);
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}

interface FiltroTipoMovimentoProps {
    disabled?: boolean;
    value: TTipoMovimento | null;
    onChange: (arg: TTipoMovimento) => void;
    required?: boolean;
    error?: boolean;
    errorMessage?: string | undefined;
    label?: string;
}